import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-5xl font-bold mb-6">Let's Fly Together</h2>
            <p className="text-gray-600 text-lg">
              We're here to assist with your private jet travel needs. Contact us via phone at +90 555 002 0006, email us at info@milajethavacilik.com, or visit our office in Ankara. We look forward to arranging your next luxurious flight experience. Book your private jet charter today!
            </p>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-line text-3xl text-white"></i>
                </div>
                <h4 className="font-bold text-xl mb-3">Email Us</h4>
                <p className="text-gray-600 mb-4">
                  Reach out to us via email for inquiries, bookings, or additional information. Our dedicated team is ready to assist you with your private jet needs.
                </p>
                <a href="mailto:info@milajets.com" className="text-blue-600 hover:text-blue-700 font-semibold cursor-pointer">
                  info@milajets.com
                </a>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-3xl text-white"></i>
                </div>
                <h4 className="font-bold text-xl mb-3">Call Us</h4>
                <p className="text-gray-600 mb-4">
                  For immediate assistance or to speak with our team directly, call us at <a href="tel:+905550020006" className="text-blue-600 hover:text-blue-700 cursor-pointer">+90 555 002 0006</a>. We are available to answer your questions and help you plan your private jet experience.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-white"></i>
                </div>
                <h4 className="font-bold text-xl mb-3">Visit Our Office</h4>
                <p className="text-gray-600 mb-4">
                  Come see us at our location in Ankara: Funda Beyaz Evler Site, Yukarı Dikmen Mah. 629. Sokak Villa No:12, Oran, Çankaya. You can also view the map{' '}
                  <a
                    href="https://www.google.com/maps/search/Funda+Beyaz+Evler+Site,+Yukarı+Dikmen+Mah.,+629.+Sokak,+Villa+No:12,+Oran,+Çankaya,+Ankara"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-700 cursor-pointer"
                  >
                    here
                  </a>{' '}
                  for directions.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
